import { EuiButtonIcon, EuiFlexGroup, EuiFlexItem } from '@elastic/eui';
import React, { useEffect, useMemo, useState } from 'react';
import { FacturasAdapter } from '../../../../../../infraestructure/persistence/rest/FacturasAdapter';
import { useNotifications } from '../../../../../../shared/hooks/Notifications';
import { ServerErrorMessage } from '../../../../../../shared/utils/error';
import ModalApp from '../../../../components/Modal';
import { CreateFecha } from '../../../../../../shared/utils/fecha';
import { DespegableDetalle } from './DespegableDetalleVisualizar';
import { toDecimalString } from '../../../../../../shared/utils/numbers';
import './styles.css';
import { useLanguage } from '../../../../../../shared/hooks/Language';

export const DescripcionFactura = (props:any)=>{
	const {data,translate} = props;
	const tipo = data.tipoFactura === 'IRPF' ? translate('irpf') : translate('retencion-hipotetica-acotado');

	return (
		<EuiFlexGroup className='descripcion-factura-detalle-historico'>
			<EuiFlexItem>
				<EuiFlexGroup>
					<EuiFlexItem grow={false}><span><strong>{`${translate('nFactura')}: `}</strong>{`${data.idFactura}`}</span></EuiFlexItem>
					<EuiFlexItem grow={false}><span><strong>{`${translate('tipo')}: `}</strong>{`${tipo}`}</span></EuiFlexItem>
					<EuiFlexItem grow={false}><span><strong>{`${translate('fecha-emision')}: `}</strong>{`${CreateFecha(data.fechaFacturacion)}`}</span></EuiFlexItem>
					<EuiFlexItem grow={false}><span><strong>{`${translate('fecha-vencimiento')}: `}</strong>{`${CreateFecha(data.fechaVencimiento)}`}</span></EuiFlexItem>
				</EuiFlexGroup>
			</EuiFlexItem>
			<EuiFlexItem grow={false}><span><strong>{`Total: `}</strong> {`${toDecimalString(data.totalFactura)}€`}</span></EuiFlexItem>
		</EuiFlexGroup>
	)
}

export const VisualizarCellRenderer = (params:any,dataFilter:any) =>{
	
	const {translate} = useLanguage();
	const {value,data} = params;
	//const {agrupacion, rolPermiso} = dataFilter;
	//const {tipoAgrupacion,agrupacionDestinoFactura} = agrupacionData

    const api:any = new FacturasAdapter();
	const {resultError, exceptionError, launchNotification} = useNotifications();
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [dataView, setDataView] = useState<any>(undefined);
	let result: any;

	const RolPermiso = useMemo(()=> data && data.rolPermiso,[data])

	// const TipoAgrupado:number = useMemo(()=>{
	// switch (tipoAgrupacion.toLowerCase()) {
	// 	case 'sociedad': return 1
	// 	case 'dn': return 2
	// 	case 'grupofactura': return 3
	// 	case 'usuario': return 4
	
	// 	default: return 0;
	// }
	// },[tipoAgrupacion])

	useEffect(()=>{
		if(isModalVisible){GetHistoricoFacturacionExpatriados(value,RolPermiso)}
	},[isModalVisible,params, RolPermiso])


	const closeModal = () => setIsModalVisible(false);
	const showModal = () => setIsModalVisible(true);

	const GetViewDetalle = useMemo(() => {
			
		if(dataView === undefined){return undefined}

		var detalleView = null;
		var totalFactura = 0;
		const initialOpen = dataView.length===1;
		
		detalleView = dataView.map((d:any)=> (<EuiFlexItem><DespegableDetalle data={d.informe} initialIsOpen={initialOpen}/></EuiFlexItem>))
		dataView.forEach((d:any)=> {totalFactura+=d.informe.total.totalFacturaPagar});
		
		return(
			<EuiFlexGroup direction='column'>
			<EuiFlexItem style={{position:'sticky',top:'-12px',zIndex:999}}><DescripcionFactura data={{...data,totalFactura}} translate={translate}/></EuiFlexItem>
			{detalleView}
			</EuiFlexGroup>
		)
		
	},[dataView,data,translate])
	
	const button = (
        <EuiButtonIcon iconType='eye' size='m' onClick={()=>showModal()}/>
    );


    const GetHistoricoFacturacionExpatriados = async (idFactura:string,rolPermiso:string) => {
		const request = {idFactura:idFactura, rolPermiso:rolPermiso, esFacturacion:false}
		try {
			// result = await api.GetHistoricoFacturacionExpatriados({idFactura:idFactura, tipoAgrupacion: TipoAgrupado, agrupacionDestinoFactura:agrupacionDestinoFactura.toString()});
			result = await api.GetHistoricoFacturacionExpatriados(request);
			if(result.data && result.data!=="")
			{
				if(result.data.length===0)
				launchNotification({type:'warning',title:'Generación del pdf',message:'No hay datos para obtener el documento'})
				else
				setDataView([...result.data])
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
			//setIsLoading(false)
		}
	};

	return(
		<>
		<EuiFlexItem>
			{button}
		</EuiFlexItem>
		<ModalApp isOpen={isModalVisible} 
		title={translate("visualizar-detalle-facturacion-historico")} 
		onClose={closeModal} content={GetViewDetalle} className='modalApp large'/>
		</>
	)
}